export default __webpack_public_path__ + "static/media/uk_cloud.dc2278ac.png";